let content = {
  terms: `By using this application, you agree to comply with these Terms & Conditions. This application is designed to facilitate healthcare services including appointment booking, teleconsultations, medical record management, laboratory services, prescriptions, and communication with licensed healthcare providers.

You agree to provide accurate and up-to-date personal and medical information. You are responsible for maintaining the confidentiality of your account credentials and for all activities performed under your account.

This application is intended to support healthcare services and does not replace professional medical advice, diagnosis, or emergency treatment. In case of a medical emergency, please visit the nearest healthcare facility or contact emergency services immediately.

We reserve the right to suspend or terminate accounts that violate these Terms, provide false information, misuse the platform, or engage in fraudulent or unlawful activities.

By clicking "I Agree", you confirm that you have read, understood, and accepted these Terms & Conditions.`,

  privacyPolicy: `Your privacy is important to us. We collect and process your personal, medical, and contact information solely for the purpose of providing healthcare services through this application.

Your information may be used to:

Manage your healthcare records.
Schedule appointments.
Facilitate consultations.
Process laboratory requests and results.
Manage prescriptions.
Improve our healthcare services.
Comply with applicable legal and regulatory requirements.

We implement appropriate administrative, technical, and physical safeguards to protect your personal and health information. Your information will not be sold or shared with unauthorized third parties.



By accepting this Privacy Policy, you consent to the collection, storage, and processing of your information as described above.`,

  shareMedRecWithDoc: `I authorize this application to securely share my medical records, including consultation history, diagnoses, laboratory reports, medications, allergies, and other relevant health information with licensed healthcare providers involved in my care.

This information will only be shared for legitimate medical purposes such as diagnosis, treatment, follow-up care, and clinical decision-making.

Access to my medical records will be limited to authorized healthcare professionals and protected using appropriate security measures.

I understand that I may withdraw my consent where permitted by law, although doing so may limit the healthcare services available to me.`,

  shareMedWithHos: `I authorize this application to securely share my medical information with participating hospitals and healthcare facilities whenever necessary for my treatment, referral, admission, emergency care, laboratory services, or other healthcare-related purposes.

Only authorized hospital personnel involved in my care will be permitted to access my records.


I understand that sharing my records helps ensure continuity and quality of medical care.`,

  ePresWithPhar: `I authorize this application to securely share my electronic prescriptions with licensed pharmacies selected by me for the purpose of dispensing prescribed medications.

The information shared may include:

Patient identification details.
Prescribing healthcare provider.
Medication name.
Dosage instructions.
Prescription date.
Refill information where applicable.

Pharmacies receiving my prescription are responsible for maintaining the confidentiality of my information and complying with applicable healthcare and data protection laws.

I understand that electronic prescriptions improve medication accuracy, reduce errors, and enhance patient safety.`,

  ePresWithDiag: `I authorize this application to securely share my electronic prescription, laboratory test requests, and relevant medical information with licensed diagnostic centers selected by me for the purpose of conducting prescribed medical tests and investigations.

The information shared may include:

Patient identification details.
Prescribing healthcare provider.
Requested laboratory or diagnostic tests.
Relevant medical history, diagnosis, or clinical notes (where necessary).
Test request date and other supporting information required to perform the requested services.


I understand that sharing my electronic prescription and laboratory requests with diagnostic centers helps ensure accurate testing, timely reporting of results, and continuity of my healthcare. I acknowledge that I may withdraw my consent where permitted by law, although doing so may affect the availability or quality of diagnostic services provided through the application`,
};

export default content;
